import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../store/auth';
import { Icon } from '../ui';
import { Avatar } from './Avatar';

/** Header profile trigger: avatar, name and role, opening My Profile / Change password / Log out. */
export function ProfileMenu() {
  const user = useAuth((s) => s.user)!;
  const logout = useAuth((s) => s.logout);
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const away = (e: MouseEvent) => {
      if (!root.current?.contains(e.target as Node)) setOpen(false);
    };
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', away);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', away);
      document.removeEventListener('keydown', esc);
    };
  }, [open]);

  const go = (to: string) => {
    setOpen(false);
    nav(to);
  };

  return (
    <div className="profile-menu" ref={root}>
      <button className="profile-trigger" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        {/* the initials repeat the name beside them, so they are left out of the button's spoken name */}
        <span aria-hidden="true" style={{ display: 'contents' }}><Avatar /></span>
        <span className="who">
          {user.name}{' '}
          <small>{user.title ?? user.role.name}</small>
        </span>
        <span className={`chev ${open ? 'open' : ''}`}><Icon name="back" /></span>
      </button>
      {open ? (
        <div className="profile-pop" role="menu">
          <div className="profile-pop-head">
            <b>{user.name}</b>
            <small>{user.email}</small>
          </div>
          <button role="menuitem" onClick={() => go('/account')}><Icon name="users" />My Profile</button>
          <button role="menuitem" onClick={() => go('/account#change-password')}><Icon name="lock" />Change password</button>
          <button role="menuitem" className="danger" onClick={() => void logout()}><Icon name="out" />Log out</button>
        </div>
      ) : null}
    </div>
  );
}
